import { EventEmitter, Injectable } from '@angular/core';

import { FileWithTask, FileForBox } from '@df/interfaces';

@Injectable({
    providedIn: 'root'
})
export class FileService {
    public selectedFiles: Array<FileWithTask> = [];
    public filesForBox: Array<FileForBox> = [];
    public filesForBoxChanged = new EventEmitter<Array<FileForBox>>();
    public filesForFiltering: Array<FileWithTask>;
    public eventFilesForFiltering = new EventEmitter<Array<FileWithTask>>();

    constructor() {}

    clearSelectedFiles() {
        this.selectedFiles.splice(0, this.selectedFiles.length);
    }

    setSelectedFiles(files: FileWithTask[]) {
        this.selectedFiles.splice(0, this.selectedFiles.length);
        this.selectedFiles.push(...files);
    }

    newFilesForBox(box_title: string) {
        const fb = <FileForBox>{ box_title: box_title, files: this.selectedFiles.slice() };
        this.filesForBox.push(fb);
    }

    changeFilesForBox(box_title: string, files: FileWithTask[]) {
        let fbx: FileForBox;
        this.setSelectedFiles(files);
        for (const fb of this.filesForBox) {
            if (box_title === fb.box_title) {
                fbx = fb;
            }
        }
        if (fbx) {
            fbx.files.splice(0, fbx.files.length);
            fbx.files.push(...files);
        } else {
            this.newFilesForBox(box_title);
        }
        this.filesForBoxChanged.emit(this.filesForBox.slice());
    }

    getFilesForBox(box_title: string): FileWithTask[] | null {
        for (const fbx of this.filesForBox) {
            if (box_title === fbx.box_title) {
                return fbx.files.slice();
            }
        }
        return null;
    }

    removeFileForBox(box_title) {
        for (const fbx of this.filesForBox) {
            if (box_title === fbx.box_title) {
                this.filesForBox.splice(this.filesForBox.indexOf(fbx), 1);
            }
        }
        this.filesForBoxChanged.emit(this.filesForBox.slice());
    }

    getFilesForBoxes(): FileForBox[] {
        return this.filesForBox.slice();
    }

    setFilesForFiltering(files: FileWithTask[]) {
        if (this.filesForFiltering && this.filesForFiltering.length > 0) {
            this.filesForFiltering.splice(0, this.filesForFiltering.length);
            this.filesForFiltering.push(...files);
        } else {
            this.filesForFiltering = files.slice();
        }
        this.eventFilesForFiltering.emit(this.getFilesForFiltering());
    }

    getFilesForFiltering(): FileWithTask[] {
        return this.filesForFiltering.slice();
    }

    emitFilesForBoxChanged() {
        this.filesForBoxChanged.emit(this.filesForBox.slice());
    }

    changedFileForBoxTitle(new_title: string, old_title: string, removeOld = true) {
        for (const fb of this.filesForBox) {
            if (fb.box_title === new_title && removeOld) {
                this.removeFileForBox(new_title);
            }
            if (fb.box_title === old_title) {
                fb.box_title = new_title;
            }
        }
    }
}
